import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class ViewTemplateService {
  // public _field_def: any = {
  //   numeric: {
  //     class_name: obj["class_name"],
  //     type: "String",
  //     component: "textbox",
  //     name: "result",
  //     hint: "Please Enter Result..."
  //   },
  //   dropdown: {
  //     "class_name": obj["class_name"],
  //     "order": 1,
  //     "type": "String",
  //     "required":obj["required"],
  //     "component": "dropdown",
  //     "name": "result"
  //   }
  // }
  _field_def: any;
  constructor(private baseService: BaseService) { }
  getFieldDef(callback) {
    this.baseService.getDataAsPerResource('GET_ALL', '', 'template', 'form-template-engine', 'name:common_template').subscribe(x => {
      this._field_def = x.resource[0].blocks[0].fields;
      callback(this._field_def);
    })
  }
  getMappedData(y: object, callback) {
    this.getFieldDef((field_def) => {
      let returnJson: any = [];
      let obj: any;
      switch (y['resultType']) {
        case 'numeric':
          obj = field_def.find(x => x.component === "textbox" && x.label === "Numeric");
          returnJson = [{
            "label": y['serviceCode'],
            "class_name": obj["class_name"],
            "order": 1,
            "type": obj["type"],
            "required": obj["required"],
            "component": obj["component"],
            "name": "result",
            "hint": obj["hint"]
          }]
          break;
        case 'dropdown':
          returnJson = [{
            "label": y['serviceCode'],
            "class_name": obj["class_name"],
            "order": 1,
            "type": "String",
            "required": obj["required"],
            "component": "dropdown",
            "name": "result"
          }]
          break;
        case 'advancetext':
          obj = field_def.find(x => x.component === "html-editor" && x.label === "Advance Text");
          returnJson = [
            {
              "label": y['serviceCode'],
              "class_name": obj["class_name"],
              "order": 1,
              "type": "String",
              "required": obj["required"],
              "component": "html-editor",
              "name": "result",
              "value": "asd"
            }]
          break;
        case 'normaltext':
          obj = field_def.find(x => x.component === "html-editor" && x.label === "Normal Text");
          returnJson = [{
            "label": y['serviceCode'],
            "class_name": obj["class_name"],
            "order": 1,
            "type": "String",
            "required": obj["required"],
            "component": "html-editor",
            "name": "result"
          }]
          break;
        case 'singleline':
          obj = field_def.find(x => x.component === "textbox" && x.label === "Single Line Text");
          returnJson = [{
            "label": y['serviceCode'],
            "class_name": obj["class_name"],
            "order": 1,
            "type": "String",
            "required": obj["required"],
            "component": "textbox",
            "name": "result",
            "hint": "Please Enter Result..."
          }]
          break;
        default:
      }
      if (y['time'] == true && y['time'] != undefined && y['time']) {
        obj = field_def.find(x => x.component === "timepicker" && x.label === "Time Picker");
        returnJson.push({
          "label": y['serviceCode'],
          "class_name": obj["class_name"],
          "order": 1,
          "type": "String",
          "required": obj["required"],
          "component": "timepicker",
          "name": "timeresult"
        });
      }
      if (y['resultType'] == 'advancetext' && y['result'] == "") {
        returnJson.push({
          "label": "Advance Text Type",
          "class_name": "kx-control col-lg-12 col-md-12 col-sm-12 col-xl-12 mb-3 fix",
          "order": 1,
          "type": "String",
          "required": "true",
          "component": "dropdown",
          "getterKey": "advanceText",
          "getterValue": "formatName",
          "default": "",
          "name": "advancetext",
          "populate_field": true,
          "req_keys": [
            "advanceText"
          ],
          "datasource": {
            "possible_value": y['advanceText']
          },
          "dependents": [{
            "dependent_field": "result",
            "action": "populate_field",
            "value": "advanceText"
          }]
        });

      }
      {
        obj = field_def.find(x => x.component === "html-editor" && x.label === "Normal Text");
        returnJson.push({
          "label": "Note",
          "class_name": obj["class_name"],
          "order": 1,
          "type": "String",
          "required": obj["required"],
          "component": "html-editor",
          "name": "note"
        });
      }
      {
        obj = field_def.find(x => x.component === "textbox");
        returnJson.push({
          "label": "Remarks",
          "class_name": obj["class_name"],
          "order": 1,
          "type": "String",
          "required": obj["required"],
          "component": "textbox",
          "name": "remarks",
          "hint": "Please Enter Remark..."
        });
      }
      {
        obj = field_def.find(x => x.component === "html-editor");
        returnJson.push({
          "label": "Interpretation",
          "class_name": obj["class_name"],
          "order": 1,
          "type": "String",
          "required": obj["required"],
          "component": "html-editor",
          "name": "interpretation"
        });
      }
      {
        obj = field_def.find(x => x.component === "textbox");
        returnJson.push({
          "label": "Advice",
          "class_name": obj["class_name"],
          "order": 1,
          "type": "String",
          "required": obj["required"],
          "component": "textbox",
          "name": "advice",
          "hint": "Please enter Advice..."
        });
      }
      {
        obj = field_def.find(x => x.component === "textbox");
        returnJson.push({
          "label": "Impression",
          "class_name": obj["class_name"],
          "order": 1,
          "type": "String",
          "required": obj["required"],
          "component": "textbox",
          "name": "impression",
          "hint": "Please enter Impression..."
        });
      }


      callback({
        "blocks": [
          {
            "name": "",
            "fields": returnJson,
            "title": ""
          }
        ]
      })
    })

  }
}
